export const queryStringGetter = (search: string): Record<string, string> => {
	const params = new URLSearchParams(search);

	const result: Record<string, string> = {};

	params.forEach((value: string, key: string) => {
		result[key] = encodeURIComponent(value);
	});

	return result;
};

export function capitalize(str: string): string {
	return str[0].toUpperCase() + str.slice(1);
}
